import type { Size } from '@/lib/types'

export function sizesToText(value: Size[]): string {
  return value.map((s) => `${s[0]}x${s[1]}`).join(', ')
}

export function parseSizes(text: string): Size[] | Error {
  const trimmed = text.trim()
  if (!trimmed) return []
  const tokens = trimmed.split(/[,\n]+/).map((t) => t.trim()).filter(Boolean)
  const out: Size[] = []
  for (const token of tokens) {
    const m = token.match(/^(\d+)\s*x\s*(\d+)$/i)
    if (!m) return new Error(`Niepoprawny rozmiar: "${token}" (oczekuję np. 300x250)`)
    out.push([Number(m[1]), Number(m[2])])
  }
  return out
}
